import React from 'react';
import './SchutzbedarfsanalyseSubNav.css';

const SchutzbedarfsanalyseSubNav = ({ activeSection, onSectionChange, availableTabs }) => {
    const allTabs = [
        { id: 'prozesse', label: 'Prozesse' },
        { id: 'anwendungen', label: 'Anwendungen' },
        { id: 'analysen', label: 'Schutzbedarfsanalysen' },
        { id: 'gap-analysen', label: 'GAP-Analyse', hasKI: true },
        { id: 'risiken', label: 'Risiken' },
        { id: 'massnahmen', label: 'Maßnahmen' },
    ];

    // Nur verfügbare Tabs anzeigen
    const visibleTabs = allTabs.filter(tab => availableTabs.includes(tab.id));

    return (
        <div className="schutzbedarfsanalyse-subnav">
            {visibleTabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`subnav-tab ${activeSection === tab.id ? 'active' : ''}`}
                    onClick={() => onSectionChange(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default SchutzbedarfsanalyseSubNav;
